import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class MatchVote extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "rating", Model.attribute('rating'));
    _defineProperty(this, "player", Model.hasOne('player'));
    _defineProperty(this, "user", Model.hasOne('user'));
    _defineProperty(this, "match", Model.hasOne('match'));
  }
}
flarum.reg.add('nagusi-match-ratings', 'common/models/MatchVote', MatchVote);